import { Injectable } from '@angular/core';
import { DATE_FORMAT } from 'app/app.config'

import * as date from 'date-fns';
import { LANGUAGE } from 'app/language/languages.const';
import { LanguageService } from 'app/language/language.service';

@Injectable()
export class DateService {

  constructor(
    private language: LanguageService
  ) { }

  public getDate(): string {
    return date.format(
        Date.now(),
        DATE_FORMAT.DASHBOARD,
        { locale: this.language.getLanguage().fns }
      );
  }

  public getTime(): any {
    return date.format(
        Date.now(),
        'HH:mm:ss'
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/date.service.ts